import React, { useMemo } from 'react';
import { Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import KotlerCardHeader from 'components/custom/KotlerCardHeader';
import CardBox from 'components/custom_v2/CardBox';
import _ from 'lodash';
import Util from 'utils/Util';

export const StockPrices = ( {
  stock: OriginalStock,
  onlyTable = false,
  license,
} ) => {
  const stock = useMemo(
    () => OriginalStock
      && OriginalStock.sort(
        ( a, b ) => ( b.newStockValue || 0 ) - ( a.newStockValue || 0 ),
      ),
    [OriginalStock],
  );

  const table = (
    <Table className="kotler-table-info-details kotler-table-info-md ">
      <TableBody>
        {_.map( stock, item => (
          <TableRow key={item.id}>
            <TableCell
              className={
                license && license.workGroup && license.workGroup.id === item.id
                  ? 'font-weight-bold text-primary text-nowrap'
                  : 'text-nowrap'
              }
              style={{ width: '130px' }}
            >
              {item.name}
            </TableCell>
            <TableCell
              className={
                license && license.workGroup && license.workGroup.id === item.id
                  ? 'font-weight-bold text-primary text-nowrap'
                  : null
              }
            >
              {Util.formatCurrency( item.newStockValue )}
            </TableCell>
            <TableCell
              className={
                license && license.workGroup && license.workGroup.id === item.id
                  ? 'font-weight-bold text-primary '
                  : null
              }
            >
              {`${item.percentagePoints}%`}
            </TableCell>
            {item && item.percentagePoints < 0 && (
              <TableCell className="pr-2">
                <i className="fa fa-arrow-down text-danger mx-2" />
              </TableCell>
            )}
            {item && item.percentagePoints > 0 && (
              <TableCell className="pr-2">
                <i className="fa fa-arrow-up text-primary mx-2" />
              </TableCell>
            )}
            {item && item.percentagePoints === 0 && (
              <TableCell className="pr-2">
                <i className="fa fa-arrow-right text-dark " />
              </TableCell>
            )}
          </TableRow>
        ) )}
      </TableBody>
    </Table>
  );
  return onlyTable ? (
    table
  ) : (
    <CardBox
      styleName="px-2 h-100"
      header={(
        <KotlerCardHeader
          hoverTitleId="stockPrices.hoverHeader"
          title="StockPrices"
          minHeight="0px"
        />
      )}
    >
      {table}
    </CardBox>
  );
};
